// 1. FIXED: Import the correct thunks from your career Redux slice
import { deleteJob, updateJob } from "../../redux/careers";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { CareersForm } from "./CareersForm";
import { ErrorBanner } from "../../components/banner";
import { IoTrash } from "react-icons/io5";
import { Section } from "../../components/section";
import { Text } from "../../components/typography";
import styled from "styled-components";
import { useEffect } from "react";

export const CareersEdit = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // 2. FIXED: Selected state.career (singular) to match your rootReducer
  // Also removed 'loading' so the form doesn't disappear when the user clicks save!
  const { error } = useSelector((state) => state.careers);

  // 3. Robust Data Catch: React Router v6 passes state directly
  const rowData = location.state;

  useEffect(() => {
    // If a user navigates directly to this URL without clicking a table row, bounce them back
    if (!rowData) {
      navigate("/careers", { replace: true });
    }
  }, [rowData, navigate]);

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to save your edits?`)) {
      // 4. FIXED: Dispatch updateJob, and RETURN it so CareersForm knows to show "Saving..."
      return dispatch(updateJob({ id: rowData.id, values }))
        .unwrap()
        .then(() => {
          navigate("/careers");
        })
        .catch((err) => {
          console.error("Failed to update job:", err);
        });
    }
  };

  const onDeleteSubmit = () => {
    if (window.confirm(`Are you sure you want to delete this job?`)) {
      // 5. FIXED: Dispatch deleteJob
      dispatch(deleteJob(rowData.id))
        .unwrap()
        .then(() => {
          navigate("/careers");
        })
        .catch((err) => {
          console.error("Failed to delete job:", err);
        });
    }
  };

  if (!rowData) return null;

  return (
    <Section>
      <SubNav>
        <li onClick={onDeleteSubmit} title="Delete Job">
          <IoTrash size={20} />
          <Text>Delete</Text>
        </li>
      </SubNav>

      {error && <ErrorBanner text={error} />}

      <CareersForm initialValues={rowData} onFormSubmit={onFormSubmit} />
    </Section>
  );
};

// --- STYLED COMPONENTS ---

const SubNav = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 2rem;

  li {
    margin-left: 1.5rem;
    display: flex;
    align-items: center;
    color: #dc3545; /* Bootstrap red for consistency */
    padding: 8px 12px;
    border-radius: 8px;
    transition: background-color 0.2s ease;

    p {
      margin: 0;
      padding: 0 0 0 0.5rem;
      color: #dc3545;
      font-weight: 500;
    }

    &:hover {
      cursor: pointer;
      background-color: #fdedec; /* Soft red hover effect to match our new UI */
    }
  }
`;
